<template>
  <div>
    <CardHeader :icon="icon1" title="工作经历" :showFold="false" />

    <div v-if="filteredList.length > 0">
      <div class="item" v-for="(item, index) in filteredList" :key="index">
        <div class="left">
          <img class="icon" :src="honorImage" alt="" />
          <div class="date">
            {{ item.timeFrom ? item.timeFrom : "" }} ~
            {{ item.timeTo ? item.timeTo : "" }}
          </div>
        </div>
        <div class="company">{{ item.company }} · {{ item.position }}</div>
      </div>
    </div>
    <div v-else style="padding-top: 24px">
      <a-empty />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CardHeader from "../card-header.vue";

export default {
  components: {
    CardHeader,
  },

  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    filteredList() {
      if (
        Array.isArray(this.detail.hisWorkList) &&
        this.detail.hisWorkList.length > 0
      ) {
        const list = [...this.detail.hisWorkList];
        list.sort((x, y) => {
          if (x.timeTo && y.timeTo) {
            if (moment(x.timeTo).isBefore(moment(y.timeTo))) {
              return 1;
            } else if (moment(x.timeTo).isAfter(moment(y.timeTo))) {
              return -1;
            } else {
              return 0;
            }
          } else {
            return 0;
          }
        });
        if (list.length > 4) {
          const [x, y] = list;
          return [x, y];
        } else {
          return list;
        }
      } else {
        return [];
      }
    },
  },

  data() {
    return {
      icon1: require("@/assets/employee/icon1.png"),
      honorImage: require("@/assets/employee/honor/honor13.png"),
    };
  },
};
</script>

<style lang="less" scoped>
.item {
  margin-bottom: 14px;
  img {
    width: 12px;
    margin-right: 4px;
  }
  .date {
    font-weight: bold;
    font-size: 14px;
  }
  .company {
    margin-top: 8px;
    padding-left: 16px;
  }
}
</style>